<!-- <app-loader *ngIf="isLoading"></app-loader> -->

<div class="community-container">
    <!-- Button -->
    <div class="header-section">
        <div class="action-row">
            <button class="ask-btn" (click)="navigate()">Ask a Question</button>
        </div>
    </div>

    <!-- Tabs & Filters -->
    <div class="controls-section">
        <div class="tabs">
            <div class="tab-item" *ngFor="let tab of (data?.tabs || [])" [class.active]="activeTab === tab"
                (click)="setActiveTab(tab)">
                {{ tab }}
            </div>
        </div>
        <div class="filters-search" *ngIf="activeTab === 'My Activity' && !noDataFound">
            <div class="filter-btn" (click)="togglePopover($event)">
                <span class="textHover">Filters</span>
                <mat-icon>filter_alt</mat-icon>
                <app-filter-popover class="filter-popover" *ngIf="showFilterPopover" [options]="filterOptions"
                    [selected]="selectedFilters" (apply)="selectedFilters = $event; applyFilter()"
                    (reset)="resetFilter()" (cancel)="showFilterPopover=false">
                </app-filter-popover>
            </div>
            <div class="search-box">
                <input #activitySearch type="text" placeholder="Search" [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearch($event)">
                <mat-icon class="search-icon" *ngIf="!searchQuery">search</mat-icon>
                <mat-icon class="search-icon clickable" *ngIf="searchQuery" (click)="clearSearch()">close</mat-icon>
            </div>
        </div>
    </div>

    <!-- Feed List -->
    <div class="feed-list" *ngIf="activeTab === 'Community Feed'">
        <ng-container *ngIf="isLoading ; else  forms">
            <app-shimmer-loader [pagination]="false" type="profileShimmer">
            </app-shimmer-loader>
        </ng-container>
        <ng-template #forms>
            <div class="feed-item" *ngFor="let item of (data?.questions || []); trackBy: trackById">
                <div class="item-header">
                    <mat-icon class="msg-icon">chat_bubble_outline</mat-icon>
                    <span class="question-meta">Question by {{ item.author }} in <a
                            (click)="goToQuestions(item.category)" class="category">{{ item.category }}</a></span>

                </div>

                <div class="item-body">
                    <div class="avatar-col">
                        <div class="avatar-circle">
                            <mat-icon>person</mat-icon>
                        </div>
                    </div>
                    <div class="content-col">
                        <h3 class="item-title">{{ item.title }}</h3>
                        <p class="item-desc">{{ item.content }}</p>

                        <div class="item-footer">
                            <span class="meta-info">{{ item.timeAgo }}</span>
                            <span class="meta-dot">•</span>
                            <span class="meta-info">{{ item.views }} Views</span>
                            <span class="meta-dot">•</span>
                            <span class="meta-info">{{ item.responses }} Response{{ item.responses !== 1 ? 's' : ''
                                }}</span>

                            <span class="official-badge" *ngIf="item.isOfficialResponse">
                                <span class="meta-dot">•</span>
                                Official Response
                                <mat-icon class="check-icon">check_circle</mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="view-all-link"
        *ngIf="activeTab === 'Community Feed'  && !isLoading && !noDataFound && data?.questions?.length>0">
        <a [routerLink]="['/community/questions']">View All Questions <mat-icon>chevron_right</mat-icon></a>
    </div>

    <!-- My Activity Table -->
    <div *ngIf="activeTab === 'My Activity' && data?.myActivity">
        <app-table [tableType]="data.myActivity.tableType" [displayedColumns]="data.myActivity.tableHeadings"
            [tableData]="data.myActivity.tableData" [tableUrls]="data.myActivity.tableUrls"
            [dataLoadComplete]="!isLoading" [showFilter]="data.myActivity.showFilterSearchRow"
            [sortableFields]="data.myActivity.sortableFields" [showPagination]="true"
            (filtersCleared)="onTableFiltersCleared()" [load]="isLoading"></app-table>
    </div>
</div>

<div class="no-data" *ngIf="(!isLoading && noDataFound && activeTab !== 'My Activity') || (!(data?.questions?.length>0) && activeTab !== 'My Activity')">
    <app-data-unavailable [content]="'Unable to load Question information.'"></app-data-unavailable>
</div>